import React from 'react';
import { Section } from './ui/Section';
export function InstructorTestimonials() {
  const testimonials = [{
    quote: 'Por fin dejé de buscar videos en YouTube antes de clase',
    text: 'Antes pasaba horas buscando qué dar. Con el Tomo 1 y el Planificador Express, ahora organizo mis clases de la semana en el café del lunes. Mis alumnos han notado la diferencia en la claridad.',
    author: 'Marc R.',
    location: 'Instructor en Barcelona'
  }, {
    quote: 'El Tomo de Retención (S.R.I.) vale oro',
    text: 'Bailar es fácil, pero mantener una clase llena es otra historia. El sistema de retención me ayudó a entender por qué perdía alumnos al tercer mes. Solo por eso, el Pack Completo se paga solo.',
    author: 'Claudia G.',
    location: 'Academia de Baile, Sevilla'
  }, {
    quote: 'Es el manual que nadie te da cuando empiezas',
    text: 'Ojalá hubiera tenido esto hace 3 años. La forma en que explica la musicalidad y el leading ha hecho que mis explicaciones sean mucho más profesionales. 100% recomendado.',
    author: 'Javi "Bachata"',
    location: 'Instructor Autónomo, Madrid'
  }, {
    quote: 'Material práctico y al grano',
    text: 'No es teoría aburrida. Son fichas, checklists y estructuras que puedes usar hoy mismo en clase. Es la mejor inversión que he hecho en mi formación como profesor.',
    author: 'Elena S.',
    location: 'Profesora de Ritmos Latinos, Valencia'
  }];
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <Section className="bg-[#1A0F2E]/80" data-id="element-163">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-4 text-brand-title" data-id="element-164">
        ⭐ LO QUE DICEN OTROS INSTRUCTORES
      </h2>
      <p className="text-center text-brand-textMuted mb-12 font-body text-sm tracking-wide" data-id="element-165">
        (Testimonios reales de la comunidad)
      </p>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-12" data-id="element-166">
        {testimonials.map((testimonial, i) => <div key={i} className="bg-gradient-card border border-brand-borderGlow/30 rounded-2xl p-6 shadow-violet-glow hover:shadow-gold-glow transition-all" data-id="element-167">
            <div className="flex text-brand-gold text-sm mb-3" data-id="element-168">⭐⭐⭐⭐⭐</div>
            <h3 className="font-heading font-bold text-brand-subtitle mb-3 text-lg" data-id="element-169">
              "{testimonial.quote}"
            </h3>
            <p className="font-body text-brand-text text-sm mb-4 leading-relaxed italic" data-id="element-170">
              {testimonial.text}
            </p>
            <div className="border-t border-brand-border/50 pt-4" data-id="element-171">
              <p className="font-heading font-semibold text-brand-subtitle text-sm" data-id="element-172">
                — {testimonial.author}
              </p>
              <p className="font-body text-brand-textMuted text-xs" data-id="element-173">
                {testimonial.location}
              </p>
            </div>
          </div>)}
      </div>

      <div className="text-center" data-id="element-174">
        <button onClick={scrollToPricing} className="font-heading bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-all hover:scale-105 active:scale-95 shadow-gold-glow-lg w-full md:w-auto tracking-wide" data-id="element-175">
          🚀 QUIERO EL MANUAL AHORA
        </button>
      </div>
    </Section>;
}